import { FormContainer, LabeledInput, Worksheet } from "uikit"
import HumanTimeSince from "components/HumanTimeSince"
import React from "react"
import { Grid } from "semantic-ui-react"
import ConnectedAccountBar from "../../ConnectedAccountBar"
import { Footer } from "./Footer"

const BasicAccountForm = ({
  data: {
    fields: { balance },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  isNew,
  lastUpdatedAt,
  account
}) => (
  <Grid>
    {account.connection_id ? (
      <Grid.Row style={{ borderBottom: "1px solid #ccc" }}>
        <Grid.Column>
          <ConnectedAccountBar {...account} />
        </Grid.Column>
      </Grid.Row>
    ) : null}
    <Grid.Row>
      <Grid.Column>
        <Worksheet error={error} style={{ borderTop: "1px solid #ccc" }}>
          <Worksheet.Body>
            <Worksheet.Row
              label={"What is the current balance of this account?"}
              description={
                account.connection_id
                  ? "Automatically updated through the account connection"
                  : null
              }
              paddedField
            >
              <Worksheet.Field error={balance.error}>
                <LabeledInput
                  {...balance}
                  label=""
                  iconText="$"
                  iconPosition="left"
                  placeholder="0"
                  disabled={!!account.connection_id}
                  data-testid="balance"
                />
                {lastUpdatedAt}
              </Worksheet.Field>
            </Worksheet.Row>
          </Worksheet.Body>
          <Footer
            isNew={isNew}
            submitLabel={submitLabel}
            onSubmit={onSubmit}
            onDelete={onDelete}
            isModified={isModified}
            deleteLabel={
              account.connection_id ? "Ignore Account" : "Delete Account"
            }
            hasConnectionId={account.connection_id ? true : false}
            error={error}
          />
        </Worksheet>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
const BasicAccountFormContainer = FormContainer(
  {
    balance: {
      type: "unit",
      required: true
    }
  },
  (fields, ...form) => {}
)(BasicAccountForm)

const BasicAccount = ({ household, account, ...formProps }) => {
  const isNew = account === null
  const values = isNew ? {} : account
  const lastUpdatedAt = !isNew ? (
    <p
      style={{
        fontSize: "0.8em",
        textAlign: "right",
        fontWeight: "normal"
      }}
    >
      Updated <HumanTimeSince time={values.balance_updated_at} /> ago
    </p>
  ) : null
  return (
    <BasicAccountFormContainer
      {...formProps}
      values={values}
      lastUpdatedAt={lastUpdatedAt}
      account={values}
    />
  )
}
export default BasicAccount
